module.exports = __webpack_public_path__ + "static/img/6.jpg.69c2977.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/6.jpg.png
// module id = K+Xs
// module chunks = 0